import { FC } from 'react';
import { OverviewTabProps } from '../types/types';
import { CommonActiveDataSource } from '../common';

export const ActiveFileDataSource: FC<OverviewTabProps> = ({ dataSource }) => {
  return dataSource ? <CommonActiveDataSource dataSource={dataSource} polling={false} /> : <div />;
};
